import { URLS } from "@/api/urls";

import { EngagementWidget } from "./EngagementWidget";
import ChannelCountOverTime from "./InsightWidgets/ChannelCountOverTime";
import ImpactScore from "./InsightWidgets/ImpactScore";
import MediaTypeShare from "./InsightWidgets/MediaTypeShare";
import MentionsOverTime from "./InsightWidgets/MentionsOverTime";
import PRValueOverTime from "./InsightWidgets/PRvalueOverTime";
import ReachOverTime from "./InsightWidgets/ReachOverTime";
import ReachOverTimeAudio from "./InsightWidgets/ReachOverTimeAudio";
import ReachOverTimeSocial from "./InsightWidgets/ReachOverTimeSocial";
import SentimentPerMedium from "./InsightWidgets/SentimentPerMedium";
import SentimentShare from "./InsightWidgets/SentimentShare";
import TopMentions from "./InsightWidgets/TopMentions";
import { WordCloud } from "./InsightWidgets/WordCloud";
import { MediaTypesWidget } from "./MediaTypesWidget";
import { MentionsWidget } from "./MentionsWidget";
import { NumMentionsWidget } from "./NumMentionsWidget";
import { PopularityScoreWidget } from "./PopularityScoreWidget";
import { PRValueWidget } from "./PRValueWidget";
import { ReachWidget } from "./ReachWidget/index.jsx";
import { SentimentWidget } from "./SentimentWidget";
import { TopChannelsWidget } from "./TopChannelsWidget";
import { WordCloudWidget } from "./WordCloudWidget";

export const METRIC_DISPLAY_MAP = {
  num_mentions: L.REPORTS_WIDGET_METRIC_TYPE_NUM_MENTIONS,
  mentions: L.REPORTS_WIDGET_METRIC_TYPE_MENTIONS,
  reach: L.REPORTS_WIDGET_METRIC_TYPE_REACH,
  sentiment: L.REPORTS_WIDGET_METRIC_TYPE_TONALITY,
  pr_value: L.REPORTS_WIDGET_METRIC_TYPE_PR_VALUE,
  popularity_score: L.REPORTS_WIDGET_METRIC_TYPE_POPULARITY_SCORE,
  top_channels: L.REPORTS_WIDGET_METRIC_TYPE_TOP_CHANNELS,
  media_types: L.REPORTS_WIDGET_METRIC_TYPE_MEDIA_TYPES,
  engagement: L.REPORTS_WIDGET_METRIC_TYPE_ENGAGEMENT,
  word_cloud: L.REPORTS_WIDGET_METRIC_TYPE_WORD_CLOUD,
};

export const METRIC_WIDGET_MAP = {
  num_mentions: NumMentionsWidget,
  mentions: MentionsWidget,
  reach: ReachWidget,
  sentiment: SentimentWidget,
  pr_value: PRValueWidget,
  popularity_score: PopularityScoreWidget,
  top_channels: TopChannelsWidget,
  media_types: MediaTypesWidget,
  engagement: EngagementWidget,
  word_cloud: WordCloudWidget,
  insights_top_channels: TopChannelsWidget,
  insights_mentions_reach: ReachWidget,
  insights_num_mentions_over_time: MentionsOverTime,
  insights_num_channels_over_time: ChannelCountOverTime,
  insights_reach_over_time: ReachOverTime,
  insights_reach_over_time_audio: ReachOverTimeAudio,
  insights_impact_score: ImpactScore,
  insights_reach_over_time_social: ReachOverTimeSocial,
  insights_sentiment_over_time_per_media_category: SentimentPerMedium,
  insights_pr_value_over_time: PRValueOverTime,
  insights_num_mentions_per_media_category: MediaTypeShare,
  insights_sentiment: SentimentShare,
  insights_word_cloud: WordCloud,
  insights_top_mentions: TopMentions,
};

export const ANALYTICS_WIDGETS_URL_MAP = {
  insights_num_mentions_over_time: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_mentions_reach: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_impact_score: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_top_channels: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_num_channels_over_time: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_reach_over_time_audio: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_reach_over_time: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_reach_over_time_social: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_sentiment_over_time_per_media_category:
    URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_sentiment: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_pr_value_over_time: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_num_mentions_per_media_category: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_word_cloud: URLS.INSIGHTS_ANALYTICS_WIDGETS,
  insights_top_mentions: URLS.INSIGHTS_ANALYTICS_WIDGETS,
};

export const REPORT_WIDGETS_URL_MAP = {
  num_mentions: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  mentions: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  reach: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  sentiment: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  pr_value: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  popularity_score: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  top_channels: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  media_types: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  engagement: URLS.SYNCHRONOUS_REPORT_WIDGETS,
  word_cloud: URLS.SYNCHRONOUS_REPORT_WIDGETS,
};
